import { render, staticRenderFns } from "./ProjectsListFilters.vue?vue&type=template&id=2bc372c0"
import script from "./ProjectsListFilters.vue?vue&type=script&lang=js"
export * from "./ProjectsListFilters.vue?vue&type=script&lang=js"
import style0 from "./ProjectsListFilters.vue?vue&type=style&index=0&id=2bc372c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports